<template>
  <v-expansion-panel popout>
    <v-expansion-panel-content v-for="(item,i) in registros" :key="i" lazy>
      <div slot="header">{{item.name}}</div>
      <v-card>
        <v-card-text>
          <PermisoComponent :model="item.id" :group="group"></PermisoComponent>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>
import Models from '../../services/models'
import PermisoComponent from '../permisos/PermisoComponent'

export default {
  name: 'ModelsLista',
  props: ['group'],
  data () {
    return {
      registros: null,
    }
  },
  components: {
    PermisoComponent
  },
  async beforeMount() {
    let res = await Models.list({populate: 'usuarioCreacion'})
    this.registros = res
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/models/ModelsLista.vue